module.exports = __webpack_public_path__ + "static/media/4.2580b2c3.svg";